import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DialogResult, DialogResultType } from "../../DialogResult";
import { ReportSource, ReportStandardType } from "../../../api/models";
import { ReportExportService } from "../../../api/services";

export interface EditReportStandardTypeDialogData {
  dialogTitle: string;
  reportStandardType: ReportStandardType;

  reportSources: ReportSource[];
}

@Component({
  selector: "edit-report-standard-type-dialog",
  styleUrls: ["edit-report-standard-type-dialog.component.css"],
  templateUrl: "./edit-report-standard-type-dialog.component.html",
})
export class EditReportStandardTypeDialogComponent {
  public Result: DialogResult;
  public uploadingReportStandardType: boolean = false;
  public reportPages: string[];
  public newReportPage: string;

  constructor(
    public dialogRef: MatDialogRef<EditReportStandardTypeDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: EditReportStandardTypeDialogData,
    private reportExportService: ReportExportService
  ) {
    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;

    this.reportPages = this.loadReportPages(this.data.reportStandardType.reportPages);
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onConfirmClick(): void {

    this.uploadingReportStandardType = true;

    if (this.data.reportStandardType.reportStandardTypeId == -1) {
      const callParams: ReportExportService.ReportExportCreateReportStandardTypeParams = {
        name: this.data.reportStandardType.name,
        reportSourceId: this.data.reportStandardType.reportSourceId,
        reportPages: this.getReportPages(),
        filterPage: this.data.reportStandardType.filterPage
      };

      this.reportExportService
        .reportExportCreateReportStandardType(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        }, (error) => {
          alert(error);
        });

    } else {
      const callParams: ReportExportService.ReportExportUpdateReportStandardTypeParams = {
        reportStandardTypeId: this.data.reportStandardType.reportStandardTypeId,
        name: this.data.reportStandardType.name,
        reportSourceId: this.data.reportStandardType.reportSourceId,
        reportPages: this.getReportPages(),
        filterPage: this.data.reportStandardType.filterPage
      };

      this.reportExportService
        .reportExportUpdateReportStandardType(callParams)
        .subscribe((result) => {
          this.Result.ResultType = DialogResultType.Ok;
          this.Result.ResultData = result;
          this.dialogRef.close(this.Result);
        }, (error) => {
          alert(error);
        });
    }
  }

  getReportPages(): string {
    return this.reportPages.join(",");
  }

  loadReportPages(reportPagesString: string): string[] {
    if (reportPagesString == null || reportPagesString.length > 0) {
      return reportPagesString.split(",");
    }

    return [];
  }

  addReportPage(): boolean {
    this.reportPages.push(this.newReportPage);
    this.newReportPage = "";

    return false;
  }

  removeReportPage(index: number): boolean {
    if (index >= 0 && index < this.reportPages.length) {
      this.reportPages.splice(index, 1);
    }

    return false;
  }

  movePageUp(index: number): boolean {
    if (this.reportPages.length > 0 && index > 0 && index < this.reportPages.length) {
      var tmp = this.reportPages[index - 1];
      this.reportPages[index - 1] = this.reportPages[index];
      this.reportPages[index] = tmp;
    }

    return false;
  }

  movePageDown(index: number): boolean {
    if (this.reportPages.length > 0 && index >= 0 && index < (this.reportPages.length - 1)) {
      var tmp = this.reportPages[index + 1];
      this.reportPages[index + 1] = this.reportPages[index];
      this.reportPages[index] = tmp;
    }

    return false;
  }
}
